<template>
  <div>
    <v-breadcrumbs
      id="breadcrumbs"
      divider=">"
      class="px-0"
      :items="breadcrumbs"
    ></v-breadcrumbs>
  </div>
</template>

<script>
export default {
  props: {
    breadcrumbs: {
      type: Array,
      required: true,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
ul.v-breadcrumbs {
  padding-top: 0px;
  padding-bottom: 8px;
}

.v-breadcrumbs {
  li {
    color: black !important;
    font-size: $text-medium-font-size-sm !important;
    letter-spacing: 0.5px;
    a {
      color: $link-color;
      font-size: $text-medium-font-size-sm !important;
      &:hover {
        font-weight: bold;
      }
    }
  }
}

@media only screen and (min-width: 960px) {
  ul.v-breadcrumbs {
    padding-bottom: 16px;
  }

  .v-breadcrumbs {
    li {
      font-size: $text-medium-font-size-lg !important;
      a {
        font-size: $text-medium-font-size-lg !important;
      }
    }
  }
}
</style>
